import { render } from "./ApplicationLogoFull.vue?vue&type=template&id=1c027f3b"
const script = {}

import exportComponent from "C:\\laragon\\www\\unensecommerce\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__